<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Nuevo selector</h3>
          <!-- Form -->
          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row>
              <!-- Reference -->
              <b-form-group
                id="input-reference"
                class="col-3"
                label="Referencia"
                label-for="reference"
              >
                <b-form-input
                  id="reference"
                  v-model="$v.form.reference.$model"
                  :state="validateState('reference')"
                  aria-describedby="input-reference-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="input-reference-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-attribute"
                class="col-3"
                label="Atributo"
                label-for="attribute"
              >
                <b-form-select
                  :options="attributeOptions"
                  id="attribute"
                  @change="attributeChanged"
                  v-model="$v.form.attribute.$model"
                  :state="validateState('attribute')"
                  aria-describedby="input-attribute-feedback"
                ></b-form-select>
                <b-form-invalid-feedback id="input-attribute-feedback"
                  >Este campo es obligatorio.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-form-row>

            <b-form-row>
              <b-form-group
                id="input-options"
                label="Opciones"
                label-for="options"
                class="col-12"
                :description="optionsPlaceholder"
              >
                <multiselect
                  tagPlaceholder="Presiona enter para añadir la opción"
                  deselectLabel="Presiona enter para quitar la opción"
                  track-by="value"
                  :class="$v.form.options.$error ? 'is-invalid' : ''"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :preserve-search="true"
                  placeholder=""
                  label="text"
                  v-model="$v.form.options.$model"
                  :options="selectedAttributeOptions"
                  :taggable="
                    $v.form.attribute.$model === 'TAMANO' ||
                    $v.form.attribute.$model === 'CAIDA' ||
                    $v.form.attribute.$model === 'TAMANO_DIAM'
                  "
                  @tag="addTag"
                >
                  <template slot="noOptions">
                    {{
                      "$v.form.attribute.$model === 'TAMANO' || $v.form.attribute.$model === 'TAMANO_DIAM' || $v.form.attribute.$model === 'CAIDA'"
                        ? 'No hay opciones definidas. Puedes añadirlas escribiéndolas'
                        : 'No hay elementos'
                    }}</template
                  >
                </multiselect>

                <small
                  v-if="$v.form.options.$error"
                  id="input-options-feedback"
                  class="invalid-options text-danger"
                >
                  Este campo es obligatorio.
                </small>
              </b-form-group>
            </b-form-row>

            <b-button type="submit" variant="primary"
              >Guardar nuevo selector</b-button
            >
          </b-form>
          <!-- /Form -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';

import {
  required,
  minLength,
  decimal,
  minValue,
} from 'vuelidate/lib/validators';

import { actions } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import { helpers } from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect';
const isValidImage = (image) =>
  !helpers.req(image) || ['image/jpeg', 'image/png'].includes(image['type']);

export default {
  name: 'AdminProductSelectorsNewScreen',
  props: {},
  components: { Multiselect },
  mixins: [validationMixin],
  validations() {
    let rules = {
      reference: {
        required,
      },
      attribute: {
        required,
      },
      options: {
        required,
        minLength: minLength(1),
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      attribute: 0.0,
      reference: '',
      attribute: 'TAMANO',
      attributes: [],
      options: [],
      error: {
        show: false,
        text: '',
      },
    };

    return {
      sharedState: store.state,
      languageCodes: store.getLanguageCodes(),
      languageNames: store.getLanguageNames(),
      attributeOptions: [],
      selectedAttributeOptions: [],
      form: form,
    };
  },
  created() {
    actions.getProductAttributesUnpaginated().then((x) => {
      this.attributeOptions = x.data.results
        .filter((z) => !['BORDADO'].includes(z.reference))
        .map((y) => {
          return {
            value: y.reference,
            text: y.reference,
          };
        });
    });
  },
  computed: {
    optionsPlaceholder() {
      if (this.$v.form.attribute.$model === 'TAMANO') {
        return 'Selecciona las opciones';
      }
      if (this.$v.form.attribute.$model === 'CAIDA') {
        return 'Selecciona las opciones';
      }
      if (this.$v.form.attribute.$model === 'TAMANO_DIAM') {
        return 'Selecciona las opciones';
      }
      if (
        this.$v.form.attribute.$model === 'HILO'
        // this.$v.form.attribute.$model === 'HILO_PUNTADA'
      ) {
        return 'Selecciona los colores';
      }
      if (this.$v.form.attribute.$model === 'TELA') {
        return 'Selecciona las telas';
      }
      if (this.$v.form.attribute.$model === 'TIRA_BORDADA') {
        return 'Selecciona las tiras bordadas';
      }
      if (this.$v.form.attribute.$model === 'TIRA_BORDADA_CON_ENTREDOS') {
        return 'Selecciona las tiras bordadas con entredós';
      }
      if (this.$v.form.attribute.$model === 'PUNTADA') {
        return 'Selecciona las puntadas';
      }
      if (this.$v.form.attribute.$model === 'BORDADO') {
        return 'Selecciona los bordados';
      }
      if (this.$v.form.attribute.$model === 'INICIALES') {
        return 'Selecciona las tipografías';
      }
    },
  },
  methods: {
    addTag(newTag) {
      const tag = {
        value: newTag,
        text: newTag,
      };
      this.selectedAttributeOptions.push(tag);
      this.$v.form.options.$model.push(tag);
    },
    attributeChanged(val) {
      this.form.options = [];
      this.selectedAttributeOptions = [];

      this.loadSelectedAttributeOptions(val);
    },
    loadSelectedAttributeOptions(val) {
      let promise = null;
      if (val === 'TELA') {
        promise = actions.getFabricsUnpaginated();
      } else if (val === 'TIRA_BORDADA' /*|| val === 'HILO_PUNTADA'*/) {
        promise = actions.getEmbroideredStripsUnpaginated();
      } else if (
        val === 'TIRA_BORDADA_CON_ENTREDOS' /*|| val === 'HILO_PUNTADA'*/
      ) {
        promise = actions.getEmbroideredStripsUnpaginated(true);
      } else if (val === 'HILO' /*|| val === 'HILO_PUNTADA'*/) {
        promise = actions.getColorsUnpaginated();
      } else if (val === 'PUNTADA') {
        promise = actions.getStitchesUnpaginated();
      } else if (val === 'BORDADO') {
      } else if (val === 'INICIALES') {
        actions.getInitial(1).then((x) => {
          this.selectedAttributeOptions = x.data.typographies.map((y) => {
            return {
              value: y.name,
              text: y.name,
            };
          });
        });
      }

      if (
        val !== 'TAMANO' &&
        val !== 'CAIDA' &&
        val !== 'TAMANO_DIAM' &&
        val !== 'INICIALES' &&
        val !== 'BORDADO'
      ) {
        // Nothing
        promise.then((x) => {
          this.selectedAttributeOptions = x.data.results.map((y) => {
            return {
              value: y.id,
              text: y.reference,
            };
          });
        });
      }
    },
    removeOption(index) {
      this.form.attributes.splice(index, 1);
    },
    addOption() {
      this.form.attributes.push({ name: '' });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = {
        reference: this.form.reference,
        attribute: this.form.attribute,
        options: this.form.options,
      };

      actions.postProductSelector(data).then((x) => {
        this.$router.push({ name: 'AdminProductSelectorsScreen' });
      });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
